<template>
  <div class="plan" v-title data-title="卓考网校|为你定制专属学习计划">
    <header class="g-header-container">
      <c-header title="学习计划" />
    </header>
    <main class="g-view-container">
      <template v-for="(item, index) in plan">
        <plan-item :key="index" class="item" :title="item.title" :list="item.detail" />
      </template>
    </main>
    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import planModel from 'models/plan';
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';
  import PlanItem from './item';

  export default {
    name: 'Plan',
    components: {
      CHeader,
      CTabbar,
      PlanItem,
    },
    created() {
      this.plan = planModel.getAllPlan();
    },
  };
</script>

<style lang="scss" scoped>
.item {
  width: 96%;
  margin: 10px auto;
}
</style>
